import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { API_CONFIG } from '../config/api.config';

// Crear instancia de axios con configuración base
const httpClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  //timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.HEADERS
});

// Interceptor para agregar el token JWT a las peticiones
httpClient.interceptors.request.use(
  async (config) => {
    // Intentar obtener el token desde localStorage
    let token = localStorage.getItem('auth_token');

    // Si no hay token, intentar refrescar el token usando el servicio de Firebase Auth
    if (!token) {
      try {
        // Importar dinámicamente el servicio de Firebase Auth para evitar dependencias circulares
        const FirebaseAuthService = await import('./firebase-auth.service').then(module => module.default);
        token = await FirebaseAuthService.refreshToken();
      } catch (error) {
        console.error('Error al refrescar el token automáticamente:', error);
      }
    }

    if (token && token !== 'null') {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
      // Si la petición requiere autenticación y no hay token, emitir un evento para notificar
      if (config.url && !config.url.includes('/api/auth/')) {
        window.dispatchEvent(new CustomEvent('auth-required', {
          detail: { url: config.url }
        }));
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar respuestas y errores
httpClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      if (error.response.status === 401) {
        localStorage.clear();
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

// Métodos para hacer peticiones HTTP
export const HttpService = {
  get: <T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    return httpClient.get<T>(url, config);
  },

  post: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    return httpClient.post<T>(url, data, config);
  },

  put: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    return httpClient.put<T>(url, data, config);
  },

  patch: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    return httpClient.patch<T>(url, data, config);
  },

  delete: <T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    return httpClient.delete<T>(url, config);
  }
};

export default HttpService;
